import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse, LDUsers } from 'types';

const useLDUsers = ({
  queries,
  enabled,
}: {
  queries: {
    wallet?: string;
  };
  enabled: boolean;
}): UseQueryResult<LDUsers, ErrorResponse> => {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }
  return useQuery([`${url.depositLdUsers}${queryParams}`], { enabled });
};
export default useLDUsers;
